module.exports = __webpack_public_path__ + "el_GR-download-ed6d1d.webp";